import { LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { TCreateEvent, TPatchEvent, TQueryEvent } from '@src/modules'

import { request } from './config'

export const createEvent = (data: TCreateEvent) => request({ url: 'event', method: 'POST', data })
export const getListEvent = (params: TQueryEvent, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'event', method: 'GET', params }, { token, lang })
export const getListEventApp = (params: TQueryEvent, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'event/app', method: 'GET', params }, { token, lang })
export const getEventById = (id: string, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: `event/${id}`, method: 'GET' }, { token, lang })
export const patchEventById = (id: string, data: TPatchEvent) => request({ url: `event/${id}`, method: 'PATCH', data })
export const removeEventById = (id: string) => request({ url: `event/${id}`, method: 'DELETE' })
export const removeManyEventByIds = (data: { ids: string[] }) =>
  request({ url: `event/delete-many`, method: 'POST', data })
export const putSlugEventById = (id: string, slug: string) =>
  request({ url: `event/${id}/slug`, method: 'PUT', data: { slug } })
export const getTotalEvent = (token?: string) => request({ url: `event/total`, method: 'GET' }, { token })
export const exportListEvent = (params: TQueryEvent, token?: string, lang = LANGUAGE_DEFAULT) =>
  request(
    {
      url: 'event/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token, lang },
  )
